// Translations for the Activate account page (runs before login).
const activateDict = [
  { en: "Invalid activation link", sw: "Kiungo cha uamilishaji si sahihi" },
  { en: "Password must be at least 8 characters", sw: "Nenosiri lazima liwe na angalau herufi 8" },
  { en: "Passwords do not match", sw: "Manenosiri hayafanani" },
  { en: "Activation failed", sw: "Uamilishaji umeshindwa" },
  { en: "Invalid activation token — the link may have expired. You can request a new activation link below.", sw: "Tokeni ya uamilishaji si sahihi — kiungo huenda kimeisha muda wake. Unaweza kuomba kiungo kipya cha uamilishaji hapa chini." },
  { en: "Activation error", sw: "Hitilafu ya uamilishaji" },
  { en: "Please enter a valid email", sw: "Tafadhali weka barua pepe sahihi" },
  { en: "Activation link resent — check your email or SMS.", sw: "Kiungo cha uamilishaji kimetumwa tena — angalia barua pepe yako au SMS." },
  { en: "Activation link resent (no preview available).", sw: "Kiungo cha uamilishaji kimetumwa tena (hakuna muhtasari unaopatikana)." },
  { en: "Failed to resend activation link", sw: "Imeshindwa kutuma tena kiungo cha uamilishaji" },
  { en: "Activate your account", sw: "Amilisha akaunti yako" },
  { en: "New Password", sw: "Nenosiri Jipya" },
  { en: "Confirm Password", sw: "Thibitisha Nenosiri" },
  { en: "Activating...", sw: "Inaamilisha..." },
  { en: "Activate Account", sw: "Amilisha Akaunti" },
  { en: "Didn't receive a working activation link? Enter your email to resend.", sw: "Hukupokea kiungo cha uamilishaji kinachofanya kazi? Weka barua pepe yako ili tutume tena." },
  { en: "Sending...", sw: "Inatuma..." },
  { en: "Resend", sw: "Tuma Tena" },
];

export default activateDict;
